import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom';
// Our components
import { CardsPage } from 'pages/Cards.page';
import { OverViewPage } from 'pages/Overview.page';
import { RewardsPage } from 'pages/Rewards.page';
import { TransactionsPage } from 'pages/Transactions.page';
import { UserProfilePage } from 'pages/UserProfile.page';
import { NotFoundPage } from 'pages/404.page';
import { UsersPage } from 'pages/Users.page';
import BusinessesSection from 'components/BusinessesSection/BusinessesSection';
import useAuth from 'Hooks/useAuth';
// Utils and Helpers
import { USER_ROLES } from 'helpers/constants';
import CustomersSection from 'components/CustomersSection/CustomersSection';

const LayoutRoutes = () => {
    const decodeState = useAuth();
    let { url } = useRouteMatch();

    const defaultUserRoute = () => {
        if (decodeState.id_role === USER_ROLES.CARD_HOLDER) {
            return <Redirect to={`${url}/cards`} />;
        }
        if (decodeState.id_role === USER_ROLES.ADMIN) {
            return <Redirect to={`${url}/overview`} />;
        }
        if (decodeState.id_role === USER_ROLES.SUPERADMIN) {
            return <Redirect to={`${url}/businesses`} />;
        }
    };
    return (
        <Switch>
            <Route exact path={url}>
                {defaultUserRoute()}
            </Route>
            <Route path={`${url}/overview`} component={OverViewPage} />
            <Route path={`${url}/cards`} component={CardsPage} />
            <Route path={`${url}/transactions`} component={TransactionsPage} />
            <Route path={`${url}/rewards`} component={RewardsPage} />
            <Route path={`${url}/profile`} component={UserProfilePage} />
            <Route path={`${url}/users`} component={UsersPage} />
            <Route path={`${url}/businesses`} component={BusinessesSection} />
            <Route path={`${url}/customers`} component={CustomersSection} />
            <Route path="*" component={NotFoundPage} />
        </Switch>
    );
};

export default LayoutRoutes;
